// external-access-api.js
import { ProtectedHttpClient } from "../shared/clients/http-client";

const ExternalAccessApi = {
  private: {
    createApiKey: () => ProtectedHttpClient.post("/external-access"), // Requires token
    getApiKey: () => ProtectedHttpClient.get("/external-access"), // Requires token
    getWebhook: () => ProtectedHttpClient.get("/external-access?accessType=webhook"), // Requires token
    createWebhook: (webhookData) => ProtectedHttpClient.post("/external-access", { 
      accessType: "webhook", 
      ...webhookData 
    }), // Requires token
    updateWebhook: (id, webhookData) => ProtectedHttpClient.patch(`/external-access/${id}`, webhookData), // Requires token
    deleteWebhook: (id) => ProtectedHttpClient.delete(`/external-access/${id}`), // Requires token
  },
};

export default ExternalAccessApi;
